function isIE() {
  var myNav = navigator.userAgent.toLowerCase();
  return (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
}

(function($) {
  var xmlns = "http://www.w3.org/2000/svg";
  var _tempDiv = null;

  $(document).ready(function() {
    if (!_tempDiv) {
      _tempDiv = document.createElement("div");
      _tempDiv.setAttribute("style", "position:absolute;top:-1000px;");
      document.body.appendChild(_tempDiv);
    }
  });

  var BASE_INCREMENTS = [
    0.05,
    0.025,
    0.02,
    0.01
  ];

  var BASE_INCREMENTS_THREE = [
    0.05,
    0.025,
    0.02,
    0.01,
    0.005,
    0.0025,
    0.002,
    0.001,
    0.0005
  ];

  var BASE_INCREMENTS_FIVE = [
    0.05,
    0.025,
    0.02,
    0.01,
    0.005,
    0.0025,
    0.002,
    0.001,
    0.0005,
    0.00025,
    0.0002,
    0.0001,
    0.00005,
    0.000025,
    0.00002,
    0.00001
  ];

  var BASE_INCREMENTS_SIX = [
    0.05,
    0.025,
    0.02,
    0.01,
    0.005,
    0.0025,
    0.002,
    0.001,
    0.0005,
    0.00025,
    0.0002,
    0.0001,
    0.00005,
    0.000025,
    0.00002,
    0.00001,
    0.000005,
    0.0000025,
    0.000002,
    0.000001
  ];

  var BASE_INCREMENTS_EIGHT = [
    0.05,
    0.025,
    0.02,
    0.01,
    0.005,
    0.0025,
    0.002,
    0.001,
    0.0005,
    0.00025,
    0.0002,
    0.0001,
    0.00005,
    0.000025,
    0.00002,
    0.00001,
    0.000005,
    0.0000025,
    0.000002,
    0.000001,
    0.0000005,
    0.00000025,
    0.0000002,
    0.0000001,
    0.00000005,
    0.000000025,
    0.00000002,
    0.00000001
  ];

  var BASE_INCREMENTS_FOUR = [
    0.05,
    0.025,
    0.02,
    0.01,
    0.005,
    0.0025,
    0.002,
    0.001,
    0.0005,
    0.00025,
    0.0002,
    0.0001
  ];

  var BASE_INCREMENTS_SEVEN = [
    0.05,
    0.025,
    0.02,
    0.01,
    0.005,
    0.0025,
    0.002,
    0.001,
    0.0005,
    0.00025,
    0.0002,
    0.0001,
    0.00005,
    0.000025,
    0.00002,
    0.00001,
    0.000005,
    0.0000025,
    0.000002,
    0.000001,
    0.0000005,
    0.00000025,
    0.0000002,
    0.0000001
  ];

  var timeInterval = {
    minute10: {
      format: function(_date, settings) {
        return getTime(moment.tz(_date, settings.timeZone), settings.timeZone);
      }
    },
    hourly: {
      format: function(_date, settings) {
        return getTime(moment.tz(_date, settings.timeZone), settings.timeZone);
      }
    },
    daily: {
      format: function(_date, settings) {
        var date = moment.tz(_date, settings.timeZone);
        var s = date.date() + " " + settings.months[date.month()].shortForm;
        date = null;
        return s;
      }
    },
    monthly: {
      format: function(_date, settings) {
        return settings.months[moment.tz(_date, settings.timeZone).month()].shortForm;
      }
    },
    yearly: {
      format: function(_date, settings) {
        return moment.tz(_date, settings.timeZone).year();
      }
    }
  };

  var xAxisInterval = {
    minute10: {
      steps: [1, 3],
      getLabel: function(_date, settings) {
        if (isExactDay(_date, settings.timeZone)) {
          var _r = xAxisInterval.daily.getLabel(_date, settings);
          _r.exact = true;
          return _r;
        }
        return {
          label: timeInterval.minute10.format(_date, settings),
          exact: false
        };
      },
      countLabels: function(_from, _to, _tz, _step) {
        var _a = moment.tz(_from, _tz);
        var _b = moment.tz(_to, _tz);
        var _d = _b.diff(_a, 'minutes');
        _a = null;
        _b = null;
        return _d > 0 ? Math.round(_d / (10 * _step)) : 0;
      },
      isLabelNeeded: function(_date, _tz, _step) {
        var date = moment.tz(_date, _tz);
        return date.minutes() % (10 * _step) == 0 &&
          date.seconds() == 0 &&
          date.milliseconds() == 0;
      },
      exactInterval: function(_date, _tz, _step) {
        var date = moment.tz(_date, _tz);
        var excessMinute10 = date.minutes() % (10 * _step);
        date = date.minutes(date.minutes() - excessMinute10);
        date = date.seconds(0);
        date = date.milliseconds(0);
        return date;
      },
      addInterval: function(_date, _tz, _step) {
        return moment.tz(_date, _tz).add((10 * _step), 'minutes');
      }
    },
    hourly: {
      steps: [1, 2, 4, 6, 12],
      getLabel: function(_date, settings) {
        if (isExactDay(_date, settings.timeZone)) {
          var _r = xAxisInterval.daily.getLabel(_date, settings);
          _r.exact = true;
          return _r;
        }
        return {
          label: timeInterval.hourly.format(_date, settings),
          exact: false
        };
      },
      countLabels: function(_from, _to, _tz, _step) {
        var _a = moment.tz(_from, _tz);
        var _b = moment.tz(_to, _tz);
        var _d = _b.diff(_a, 'hours');
        return _d > 0 ? Math.round(_d / _step) : 0;
      },
      isLabelNeeded: function(_date, _tz, _step) {
        _date = moment.tz(_date, _tz);
        return _date.hours() % _step == 0 &&
          _date.minutes() == 0 &&
          _date.seconds() == 0 &&
          _date.milliseconds() == 0;
      },
      exactInterval: function(_date, _tz, _step) {
        var date = moment.tz(_date, _tz);
        var excessHour = date.hours() % _step;
        date = date.hours(date.hours() - excessHour);
        date = date.minutes(0);
        date = date.seconds(0);
        date = date.milliseconds(0);
        return date;
      },
      addInterval: function(_date, _tz, _step) {
        return moment.tz(_date, _tz).add(_step, 'hours');
      }
    },
    daily: {
      steps: [1, 2, 3, 5, 7, 14],
      getLabel: function(_date, settings) {
        if (isExactMonth(_date, settings.timeZone)) {
          var _r = xAxisInterval.monthly.getLabel(_date, settings);
          _r.exact = true;
          return _r;
        }
        return {
          label: timeInterval.daily.format(_date, settings),
          exact: false
        };
      },
      countLabels: function(_from, _to, _tz, _step) {
        var _a = moment.tz(_from, _tz);
        var _b = moment.tz(_to, _tz);
        var _d = _b.diff(_a, 'days');
        return _d > 0 ? Math.round(_d / _step) : 0;
      },
      isLabelNeeded: function(_date, _tz, _step) {
        var date = moment.tz(_date, _tz);
        return (date.dayOfYear() - 1) % _step == 0 &&
          date.hours() == 0 &&
          date.minutes() == 0 &&
          date.seconds() == 0 &&
          date.milliseconds() == 0;
      },
      exactInterval: function(_date, _tz, _step) {
        var date = moment.tz(_date, _tz);
        var excessDay = (date.dayOfYear() - 1) % _step;
        date = date.dayOfYear(date.dayOfYear() - excessDay);
        date = date.hours(0);
        date = date.minutes(0);
        date = date.seconds(0);
        date = date.milliseconds(0);
        return date;
      },
      addInterval: function(_date, _tz, _step) {
        return moment.tz(_date, _tz).add(_step, 'days');
      }
    },
    monthly: {
      steps: [1, 2, 3, 4, 6],
      getLabel: function(_date, settings) {
        if (isExactYear(_date, settings.timeZone)) {
          var _r = xAxisInterval.yearly.getLabel(_date, settings);
          _r.exact = true;
          return _r;
        }
        return {
          label: timeInterval.monthly.format(_date, settings),
          exact: false
        };
      },
      countLabels: function(_from, _to, _tz, _step) {
        var _a = moment.tz(_from, _tz);
        var _b = moment.tz(_to, _tz);
        var _d = _b.diff(_a, 'months');
        return _d > 0 ? Math.round(_d / _step) : 0;
      },
      isLabelNeeded: function(_date, _tz, _step) {
        var date = moment.tz(_date, _tz);
        return date.month() % _step == 0 &&
          date.date() == 1 &&
          date.hours() == 0 &&
          date.minutes() == 0 &&
          date.seconds() == 0 &&
          date.milliseconds() == 0;
      },
      exactInterval: function(_date, _tz, _step) {
        var date = moment.tz(_date, _tz);
        var excessMonth = date.month() % _step;
        date = date.month(date.month() - excessMonth);
        date = date.date(1);
        date = date.hours(0);
        date = date.minutes(0);
        date = date.seconds(0);
        date = date.milliseconds(0);
        return date;
      },
      addInterval: function(_date, _tz, _step) {
        return moment.tz(_date, _tz).add(_step, 'months');
      }
    },
    yearly: {
      steps: [1, 2, 4, 10],
      getLabel: function(_date, settings) {
        return {
          label: timeInterval.yearly.format(_date, settings),
          exact: false
        };
      },
      countLabels: function(_from, _to, _tz, _step) {
        var _a = moment.tz(_from, _tz);
        var _b = moment.tz(_to, _tz);
        var _d = _b.diff(_a, 'years');
        return _d > 0 ? Math.round(_d / _step) : 0;
      },
      isLabelNeeded: function(_date, _tz, _step) {
        var date = moment.tz(_date, _tz);
        return date.year() % _step == 0 &&
          date.dayOfYear() == 1 &&
          date.hours() == 0 &&
          date.minutes() == 0 &&
          date.seconds() == 0 &&
          date.milliseconds() == 0;
      },
      exactInterval: function(_date, _tz, _step) {
        var date = moment.tz(_date, _tz);
        var excessYear = date.year() % _step;
        date = date.year(date.year() - excessYear);
        date = date.month(0);
        date = date.date(1);
        date = date.hours(0);
        date = date.minutes(0);
        date = date.seconds(0);
        date = date.milliseconds(0);
        return date;
      },
      addInterval: function(_date, _tz, _step) {
        return moment.tz(_date, _tz).add(_step, 'years');
      }
    }
  };

  var dolog = function(_text) {
    if (console && console.log) {
      console.log(_text);
    }
  };

  var isExactDay = function(_date, _tz) {
    var date = moment.tz(_date, _tz);
    return date.hours() == 0 && date.minutes() == 0;
  };

  var isExactMonth = function(_date, _tz) {
    return moment.tz(_date, _tz).date() == 1;
  };

  var isExactYear = function(_date, _tz) {
    return moment.tz(_date, _tz).month() == 0;
  };

  var getTime = function(_date, _tz) {
    var date = moment.tz(_date, _tz);
    var a_p = "";
    var curr_hour = date.hours();
    if (curr_hour < 12) {
      a_p = "AM";
    } else {
      a_p = "PM";
    }
    if (curr_hour == 0) {
      curr_hour = 12;
    }
    if (curr_hour > 12) {
      curr_hour = curr_hour - 12;
    }
    var curr_min = date.minutes();

    return (curr_hour + ":" + leadChar(curr_min, 2, '0') + " " + a_p);
  };

  var leadChar = function(_text, _charCount, _leadChar) {
    _text = _text + "";
    while (_text.length < _charCount) {
      _text = _leadChar + _text;
    }
    return _text;
  };

  function numberWithCommas(x, _scale) {
    x = x + "";
    var parts = x.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (parts.length == 0 && _scale > 0) {
      parts.push('00');
    }
    return parts.join(".");
  }

  var getBoundingBox = function(text, style) {
    var svge = document.createElementNS(xmlns, "svg");
    var t = document.createElementNS(xmlns, "text");
    t.setAttributeNS(null, "style", style);
    t.appendChild(document.createTextNode(text));
    svge.appendChild(t);
    _tempDiv.appendChild(svge);
    var bbox = t.getBBox();

    _tempDiv.innerHTML = ""; // remove from the div
    svge = null;
    t = null;
    return bbox;
  };

  var types = {
    line: function(options) {
      if (!document.createElementNS) {
        return false;
      }
      var settings = $.extend({
        'timeZone': moment.tz.guess(),
        'margin': {
          top: 5,
          bottom: 5,
          left: 10,
          right: 5
        },
        //                'width'             : 320,
        //                'height'            : 150,
        'preserveAspectRatio': 'none',
        'fontFamily': 'Arial',
        'fontSize': 8,
        'fontColor': '#000000',
        'logoColor': '#b37329',
        'gridColor': "#F0F0F0",
        'gridHorizontalOffset': 0,
        'borderColor': "#686868",
        'cursorPointStrokeColor': 'black',
        'cursorPointColor': 'red',
        'cursorPointSize': 2,
        'timeBoxMarginTop': 0,
        'timeBoxArrow': 8,
        'timeBoxRight': 20,
        'timeBoxHeight': 18,
        'timeBoxWidth': 160,
        'valueBoxWidth': 80,
        'timeBoxWidthOffset': 20,
        'timeBoxBackgroundColor': '#ba731d',
        'timeBoxFontColor': '#fff',
        'timeBoxBorderColor': 'none',
        'valueBoxYOffset': 0,
        'offsetChart': true,
        'dataSeries': [], //{name : [{time, data}], startDate, area, color[optional]}

        'months': [{
            longForm: "January",
            shortForm: "Jan"
          },
          {
            longForm: "February",
            shortForm: "Feb"
          },
          {
            longForm: "March",
            shortForm: "Mar"
          },
          {
            longForm: "April",
            shortForm: "Apr"
          },
          {
            longForm: "May",
            shortForm: "May"
          },
          {
            longForm: "June",
            shortForm: "Jun"
          },
          {
            longForm: "July",
            shortForm: "Jul"
          },
          {
            longForm: "August",
            shortForm: "Aug"
          },
          {
            longForm: "September",
            shortForm: "Sep"
          },
          {
            longForm: "October",
            shortForm: "Oct"
          },
          {
            longForm: "November",
            shortForm: "Nov"
          },
          {
            longForm: "December",
            shortForm: "Dec"
          }
        ],
        retailCurrencySymbol: "",
        retailCurrencyName: "SGD",
        retailWeightSymbol: "g",
        showWeightSymbol: false,
        isRetailDisplay: false,
        labelLineColor: ""

      }, options);

      var data = {
        max: null,
        min: null,
        range: null,
        fromDate: null,
        toDate: null,
        startValue: null,
        endValue: null,
        dateRange: null,
        withCurrency: false,
        font: "font-family:" + settings.fontFamily + ";font-size:" + settings.fontSize + "px;",
        currency: {
          symbol: '',
          left: true,
          name: "USD"
        }
      };

      // entire chart
      var chart = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };

      // chart minus padding
      var chartArea = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };

      // chart minus padding
      var headerArea = {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        margin: 10
      };

      var xAxisArea = {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        labelPadding: 7,
        tickValues: [], // {x-coordinate, label}
        tickLength: 5,
        tickLabelSpacing: 2,
        top: false
      };

      var yAxisArea = {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        maxTickValue: 0,
        minTickValue: 0,
        tickRange: 0,
        tickLength: 5,
        tickLabelSpacing: 2,
        majorUnit: 0,
        majorUnitLabel: 0,
        majorUnitPadding: 4, // spacing between labels
        scale: 0,
        tickPosition: [],
        left: false
      };

      // chartArea minus xAxis and yAxis area
      var plotArea = {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        borderColor: settings.borderColor
      };

      var dataSeries = []; // {name, area, data:[{date, value}], points, pointsmap }

      // collect info from data, make data as date
      var setupChartData = function() {
        var setupSuccess = true;

        //                console.log(localOffset);
        //                console.log(localOffset + settings.serverOffset);
        //                console.log(timeOffset);

        var maxNumDecimals = 0;
        data.minRange = 0.0;
        $.each(settings.dataSeries, function(k, o) {
          if (o.data && o.data.length > 0) {
            if (!data.fromDate || data.fromDate.toDate().getTime() < o.data[0].date) {
              data.fromDate = moment.tz(o.data[0].d * 100000 + o.startDate, settings.timeZone);
            }
            if (!data.toDate || data.toDate.toDate().getTime() > o.data[o.data.length - 1].date) {
              data.toDate = moment.tz(o.data[o.data.length - 1].d * 100000 + o.startDate, settings.timeZone);
            }
          } else {
            setupSuccess = false;
            return false;
          }
          var _new = {
            name: k,
            area: o.area,
            color: o.color,
            lineColor: o.lineColor,
            lineWidth: o.lineWidth,
            numDecimals: o.numDecimals,
            data: []
          };
          var _val = null;
          $.each(o.data, function(i, v) {
            var _date = new Date(v.d * 100000 + o.startDate);
            _val = v.v;
            data.min = (i === 0 || _val < data.min) ? _val : data.min;
            data.max = (i === 0 || _val > data.max) ? _val : data.max;
            if (!data.startValue) data.startValue = _val;
            _new.data.push({
              date: _date,
              value: _val
            });
            _date = null;
          });
          data.endValue = _val;
          dataSeries.push(_new);
          _new = null;

          //dolog('min=' + data.min + ' max=' + data.max);

          if (o.numDecimals > maxNumDecimals) {
            maxNumDecimals = o.numDecimals;
          }
          data.numDecimals = o.numDecimals;
          if (typeof o.minRange === 'undefined') {
            data.minRange = 1;
            var n = data.numDecimals;
            while (n-- > 1) {
              data.minRange /= 10;
            }
            /*                        data.minRange = data.max / 1000.0;
             if (data.minRange < 0.1) {
             data.minRange = 0.1;
             }*/
          } else {
            data.minRange = o.minRange;
          }
        });


        if (setupSuccess) {
          data.dateRange = data.toDate.diff(data.fromDate);
          data.range = data.max - data.min;
          data.numDecimals = maxNumDecimals;

          if (typeof settings.baseInc === 'undefined') {
            if (data.numDecimals == 6) {
              data.baseInc = BASE_INCREMENTS_SIX;
            } else if (data.numDecimals == 8) {
              data.baseInc = BASE_INCREMENTS_EIGHT;
            } else if (data.numDecimals == 7) {
              data.baseInc = BASE_INCREMENTS_SEVEN;
            } else if (data.numDecimals == 5) {
              data.baseInc = BASE_INCREMENTS_FIVE;
            } else if (data.numDecimals == 4) {
              data.baseInc = BASE_INCREMENTS_FOUR;
            } else if (data.numDecimals == 3) {
              data.baseInc = BASE_INCREMENTS_THREE;
            } else {
              data.baseInc = BASE_INCREMENTS;
            }
          } else {
            data.baseInc = settings.baseInc;
          }
        }

        return setupSuccess;
      };

      var adjustHighestPoint = function(increment) {
        var high = data.max - (data.max % increment) + increment;
        //                if(data.max == data.min || (high - (increment * 0.1)) < data.max){  // if max value is above 90% of the top interval
        high = high + increment; // add another interval above
        //                }
        return high;
      };


      var adjustLowestPoint = function(increment) {
        var low = data.min - (data.min % increment);
        //                if(data.max == data.min || (low + (increment * 0.1)) > data.min){   // if min value is within 10% of the bottom interval
        low = low - increment; // add another interval below
        //low = data.min - data.min*0.1;
        //                }

        if (low < 0) {
          low = 0;
        }
        return low;
      };

      var isGoodFit = function(increment, range, sampleLabelBBox, min, max, low, high) {
        var intervalCount = range / increment;
        //dolog("isGoodFit inc: " + increment + " range:" + range + "intervalCount" + intervalCount + " sampleLabelBBox.height:" + sampleLabelBBox.height);
        var expectedLabelHeight = sampleLabelBBox.height + yAxisArea.majorUnitPadding;
        var actualLabelHeight = yAxisArea.height / intervalCount;

        if (actualLabelHeight >= expectedLabelHeight) {
          //dolog("good fit");
          return true;
        } else {
          //dolog("labels don't fit.");
          return false;
        }
      };

      var setupYAxisLabels = function() {
        var goodFit = false;
        var scale = 0;
        var high = 0;
        var low = 0;
        var range = 0;
        var increment = 0;
        var power = 0;
        var i = 0;
        var sampleLabelBBox = getBoundingBox(data.max, data.font);
        //var BASE_INC = BASE_INCREMENTS;
        var BASE_INC = data.baseInc;

        //dolog('setupYAxisLabels data.max: ' + data.max + ' data.min: ' + data.min);
        if (data.max == data.min) {
          //dolog('setupYAxisLabels minRange: ' + data.minRange);
          while (power < 10) {
            i = BASE_INC.length;
            while (i--) {
              increment = BASE_INC[i] * Math.pow(10, power);
              yAxisArea.majorUnit = increment;
              yAxisArea.scale = data.numDecimals;
              yAxisArea.maxTickValue = adjustHighestPoint(yAxisArea.majorUnit);
              yAxisArea.minTickValue = adjustLowestPoint(yAxisArea.majorUnit);
              yAxisArea.tickRange = yAxisArea.maxTickValue - yAxisArea.minTickValue;

              if (yAxisArea.tickRange >= data.minRange) {
                break;
              }
            }

            if (yAxisArea.tickRange >= data.minRange) {
              break;
            }

            power++;
          }
        } else {
          while (!goodFit && power < 10) {
            i = BASE_INC.length;
            while (i--) {
              scale = data.numDecimals;
              increment = BASE_INC[i] * Math.pow(10, power);
              var max = data.max + (((data.max - data.min) * 0.1) / 2);
              var min = data.min - (((data.max - data.min) * 0.1) / 2);
              high = max - (max % increment) + increment;
              low = min - (min % increment);
              high = parseFloat(high.toFixed(scale));
              low = parseFloat(low.toFixed(scale));
              //high = adjustHighestPoint(increment);
              //low = adjustLowestPoint(increment);
              if (low < 0) {
                low = 0;
              }
              range = high - low;
              range = range.toFixed(scale);


              //dolog('test inc:' + increment);
              if (range >= data.minRange) {
                goodFit = isGoodFit(increment, range, sampleLabelBBox);
                if (goodFit) {
                  //dolog('setting tick values. high:' + high + " low:" + low + " inc:" + increment + " range:" + range + " scale:" + scale);
                  yAxisArea.maxTickValue = high;
                  yAxisArea.minTickValue = low;
                  yAxisArea.tickRange = range;
                  yAxisArea.majorUnit = increment;
                  yAxisArea.scale = scale;
                  break;
                }
              } else {
                //dolog('not testing since range<data.minRange. range:' + range + " data.minRange: " + data.minRange + " high: " + high + " low: " + low + " scale: " + scale);
              }
            }

            power++;

          }
        }

        if (yAxisArea.scale == 6) {
          yAxisArea.majorUnitLabel = parseFloat(Math.round(yAxisArea.majorUnit * 1000000) / 1000000);
        } else if (yAxisArea.scale == 8) {
          yAxisArea.majorUnitLabel = parseFloat(Math.round(yAxisArea.majorUnit * 100000000) / 100000000);
        } else if (yAxisArea.scale == 7) {
          yAxisArea.majorUnitLabel = parseFloat(Math.round(yAxisArea.majorUnit * 10000000) / 10000000);
        } else if (yAxisArea.scale == 5) {
          yAxisArea.majorUnitLabel = parseFloat(Math.round(yAxisArea.majorUnit * 100000) / 100000);
        } else if (yAxisArea.scale == 4) {
          yAxisArea.majorUnitLabel = parseFloat(Math.round(yAxisArea.majorUnit * 10000) / 10000);
        } else if (yAxisArea.scale == 3) {
          yAxisArea.majorUnitLabel = parseFloat(Math.round(yAxisArea.majorUnit * 1000) / 1000);
        } else {
          yAxisArea.majorUnitLabel = parseFloat(Math.round(yAxisArea.majorUnit * 100) / 100);
        }

        //dolog("majorUnitLabel: " + yAxisArea.majorUnitLabel);
      };

      var dateFormat = function(_date, _tz) {
        _date = moment.tz(_date, _tz);
        if (settings.hasTime) {
          return _date.date() + " " + settings.months[_date.month()].longForm + " " + _date.year() + " " + getTime(_date, _tz);
        } else {
          return _date.date() + " " + settings.months[_date.month()].longForm + " " + _date.year();
        }
      };

      var getDateWithLabels = function(fromDate, toDate, xAxisInt, _step) {
        var labelCount = xAxisInt.countLabels(fromDate, toDate, settings.timeZone, _step);

        var dates = [];
        if (labelCount === 0) return dates;

        xAxisArea.tickValues.length = 0;
        var maxXCoordinate = 0;

        var tempDateTime = fromDate;
        var _label;
        var _text;
        var _bounds;

        var checkLabelOverlap = function() {
          _label = xAxisInt.getLabel(tempDateTime, settings);
          _text = _label.label;
          _bounds = getBoundingBox(_text, data.font);

          var _x = getXCoordinate(tempDateTime);
          if (i > 0) {
            // this tests if the x coordinate is less than the current label width
            // total (including spacing between). If true, suggests that the current
            // xAxisInterval/step is too compact and the labels will overlap.
            if (_x < maxXCoordinate) {
              return true;
            }
          }

          maxXCoordinate = _x + _bounds.width + xAxisArea.labelPadding;
          xAxisArea.tickValues.push({
            x: _x,
            label: _label
          });

          return false;
        };

        var checkFirstLabel = true;

        if (xAxisInt.isLabelNeeded(fromDate, settings.timeZone, _step)) {
          if (checkLabelOverlap()) {
            return false;
          }

          if (settings.offsetChart) {
            if (xAxisArea.tickValues[0] && xAxisArea.tickValues[0].label) {
              var _bounds1st = getBoundingBox(xAxisArea.tickValues[0].label.label || xAxisArea.tickValues[0].label, data.font);
              var _offset = Math.round(_bounds1st.width / 2);
              if ((xAxisArea.tickValues[0].x - _offset) < chartArea.x) {
                plotArea.offset = _offset;
                plotArea.width = plotArea.width - plotArea.offset;
                checkFirstLabel = false;
              }
            }
          }
        } else {
          tempDateTime = xAxisInt.exactInterval(tempDateTime, settings.timeZone, _step);
        }

        for (var i = 0; i < labelCount; i++) {
          tempDateTime = xAxisInt.addInterval(tempDateTime, settings.timeZone, _step);
          if (tempDateTime.toDate().getTime() < toDate.toDate().getTime()) {
            if (checkLabelOverlap()) {
              return false;
            }
          }

          var _tickVal = xAxisArea.tickValues[xAxisArea.tickValues.length - 1];

          if (checkFirstLabel && _tickVal.label) {
            checkFirstLabel = false;
            var _bounds1st = getBoundingBox(_tickVal.label.label || _tickVal.label.label, data.font);
            var _offset = Math.round(_bounds1st.width / 2);
            if ((checkFirstLabel.x - _offset) < chartArea.x) {
              plotArea.offset = _offset;
              plotArea.width = plotArea.width - plotArea.offset;
            }
          }
        }
        tempDateTime = xAxisInt.addInterval(tempDateTime, settings.timeZone, _step);
        if (tempDateTime.toDate().getTime() <= toDate.toDate().getTime()) {
          if (checkLabelOverlap()) {
            return false;
          }
        }

        return true;
      };

      var getYCoordinate = function(_value) {
        var positionWrtRange = (_value - yAxisArea.minTickValue) / yAxisArea.tickRange;
        var r = Math.round(yAxisArea.height - positionWrtRange * yAxisArea.height);
        return r;
      };

      var getXCoordinate = function(_date) {
        var date = moment.tz(_date, settings.timeZone);
        var positionWrtRange = (date.toDate().getTime() - data.fromDate.toDate().getTime()) / data.dateRange;
        date = null;
        return Math.round(positionWrtRange * (plotArea.width - 1));
      };

      var setupXAxisLabels = function() {
        var _intervalSelected = false;
        $.each(xAxisInterval, function(k, xAxisInt) {
          $.each(xAxisInt.steps, function(_index, _step) {
            var datesWithLabels = getDateWithLabels(data.fromDate, data.toDate, xAxisInt, _step);
            if (!datesWithLabels) {
              plotArea.width = xAxisArea.width;
              plotArea.offset = null;
              return true;
            }

            _intervalSelected = true;
            return false;
          });
          return !_intervalSelected; // break if interval already selected.
        });
      };

      var getValueRounded = function(_value, _scale, _withUnit, _symbol, _left) {
        var _scaledVal = null;
        if (_scale > 0) {
          var _s = Math.pow(10, _scale);
          _scaledVal = parseFloat(Math.round(_value * _s) / _s).toFixed(_scale);
        } else {
          _scaledVal = parseFloat(_value).toFixed(0);
        }
        return _scaledVal;
      };

      var getValueLabel = function(_value, _scale, _withUnit, _symbol, _left) {
        var _scaledVal = numberWithCommas(_value, _scale);
        if (_withUnit) {
          if (_left) {
            return _symbol + _scaledVal;
          } else {
            return _scaledVal + _symbol;
          }
        }
        return _scaledVal;
      };

      var getValueLabel2 = function(_value, _scale, _withUnit, _symbol, _left, _withWeightSymbol, _weightSymbol) {
        var valueLabel = numberWithCommas(getValueRounded(_value, _scale, _withUnit, _symbol, _left), _scale);
        if (_withUnit && !settings.isRetailDisplay) {
          if (_left) {
            valueLabel = _symbol + valueLabel;
          } else {
            valueLabel = valueLabel + _symbol;
          }
        } else if (settings.isRetailDisplay) {
          valueLabel = settings.retailCurrencySymbol + valueLabel;
        }
        if (_withWeightSymbol && settings.retailWeightSymbol && settings.isRetailDisplay) {
          valueLabel = valueLabel + "/" + settings.retailWeightSymbol;
        }

        return valueLabel;
      };

      var getYLabelsMaxWidth = function() {
        var minValWidth = getBoundingBox(getValueLabel2(yAxisArea.minTickValue, yAxisArea.scale, data.withCurrency, data.currency.symbol, data.currency.left), data.font).width;
        var maxValWidth = getBoundingBox(getValueLabel2(yAxisArea.maxTickValue, yAxisArea.scale, data.withCurrency, data.currency.symbol, data.currency.left), data.font).width;
        return maxValWidth > minValWidth ? maxValWidth : minValWidth;
      };

      // ****************************************************
      //    Setup position and dimensions of graph elements
      // ****************************************************
      var container = $(this);

      if (isIE()) { // IE does not support svg without width element.
        container.resize(function() {
          svgContainer.setAttributeNS(null, "width", "" + container.width());
        });
      }

      chart.height = settings.height ? settings.height : container.height();
      chart.width = settings.width ? settings.width : container.width();

      chartArea.height = chart.height - settings.margin.top - settings.margin.bottom;
      chartArea.width = chart.width - settings.margin.left - settings.margin.right;
      chartArea.x = chart.x + settings.margin.left;
      chartArea.y = chart.y + settings.margin.top;

      var successSetup = setupChartData();

      if (settings.withStatistics) {
        if (settings.chartStatsCallback) {

        } else {
          headerArea.x = chartArea.x;
          headerArea.y = chartArea.y;
          headerArea.titleHeight = getBoundingBox("J", data.font).height;
          headerArea.height = (settings.chartTitle ? 2 : 1) * getBoundingBox("J", data.font).height + headerArea.margin;
          chartArea.y = chart.y + headerArea.height;
          chartArea.height = chartArea.height - headerArea.height;
        }
      }

      if (successSetup) {
        xAxisArea.height = getBoundingBox("J", data.font).height + xAxisArea.tickLength + xAxisArea.tickLabelSpacing;

        plotArea.height = chartArea.height - xAxisArea.height;

        yAxisArea.height = plotArea.height;

        setupYAxisLabels();

        yAxisArea.width = getYLabelsMaxWidth() + yAxisArea.tickLength + yAxisArea.tickLabelSpacing + 2;

        if (settings.plotWidth) {
          plotArea.width = settings.plotWidth;
        } else {
          plotArea.width = chartArea.width - yAxisArea.width;
        }

        xAxisArea.width = plotArea.width;

        setupXAxisLabels();

        xAxisArea.x = chartArea.x;
        xAxisArea.y = xAxisArea.top ? chartArea.y : chartArea.y + plotArea.height;

        yAxisArea.x = yAxisArea.left ? chartArea.x : chartArea.x + xAxisArea.width;
        yAxisArea.y = chartArea.y;

        plotArea.x = yAxisArea.left ? yAxisArea.x + yAxisArea.width : chartArea.x;
        plotArea.x = plotArea.offset ? plotArea.x + plotArea.offset : plotArea.x;
        plotArea.y = xAxisArea.top ? xAxisArea.y + xAxisArea.height : chartArea.y;
      }


      var svgContainer = null;

      var drawContainer = function() {
        var svg = container.children('svg');
        var newViewBox = "0 0 " + chart.width + " " + chart.height;
        if (svg.length > 0) {
          svgContainer = svg.get(0);
          var vb = svgContainer.getAttributeNS(null, "viewBox");
          //console.log('vb=' + vb + ' new=' + newViewBox);
          if (vb != newViewBox) {
            svgContainer.setAttributeNS(null, "viewBox", newViewBox);
          }
          svg.empty();
        } else {
          svgContainer = document.createElementNS(xmlns, "svg");
          svgContainer.setAttributeNS(null, "viewBox", newViewBox);
          svgContainer.setAttributeNS(null, "version", "1.1");
          if (isIE()) {
            svgContainer.setAttributeNS(null, "width", "" + chart.width);
          }
          svgContainer.setAttributeNS(null, "preserveAspectRatio", settings.preserveAspectRatio);
          svgContainer.setAttributeNS(null, "width", "100%");
          svgContainer.setAttributeNS(null, "height", "100%");
          container.html(svgContainer);
        }
      };


      var calculatePoints = function(_index) {
        var _x = null;
        var _prevX = null;
        var _sameX = null;
        var _y = null;
        var _prevY = null;
        var _date = null;
        var _value = null;
        dataSeries[_index].pointsmap = {};
        dataSeries[_index].points = "";
        $.each(dataSeries[_index].data, function(i, v) {
          _x = (plotArea.x + getXCoordinate(v.date));
          _y = (plotArea.y + getYCoordinate(v.value));
          dataSeries[_index].points += _x + "," + _y + " ";
          /*if(_prevX){
           _sameX = _prevX;
           while((++_prevX) < _x){
           dataSeries[_index].pointsmap[_prevX] = {x : _sameX, y : _prevY, date : v.date, value : v.value};
           }
           }*/
          if (_x > plotArea.x || !(_x in dataSeries[_index].pointsmap)) {
            dataSeries[_index].pointsmap[_x] = {
              x: _x,
              y: _y,
              date: v.date,
              value: v.value
            };
          }
          _prevX = _x;
          _prevY = _y;
          _date = v.date;
          _value = v.value;
        });
        dataSeries[_index].points += (plotArea.x + plotArea.width) + "," + _y + " ";
        dataSeries[_index].pointsmap[_x] = {
          x: _x,
          y: _y,
          date: _date,
          value: _value
        };
        dataSeries[_index].pointsmaplastkey = _x;
      };

      var drawTitle = function() {
        var _text = document.createElementNS(xmlns, "text");
        var _span = document.createElementNS(xmlns, "tspan");
        _span.setAttributeNS(null, "fill", "#424242");
        _span.setAttributeNS(null, "style", data.font);
        _span.appendChild(document.createTextNode(settings.chartTitle));
        _text.appendChild(_span);
        _text.setAttributeNS(null, "x", headerArea.x + (plotArea.offset || 0));
        _text.setAttributeNS(null, "y", headerArea.y + headerArea.titleHeight);
        svgContainer.appendChild(_text);
      }

      var drawFieldLabel = function(_flval, _textCont) {
        var _span = document.createElementNS(xmlns, "tspan");
        _span.setAttributeNS(null, "fill", "#8f6b51");
        _span.setAttributeNS(null, "style", data.font);
        _span.appendChild(document.createTextNode(_flval));
        _textCont.appendChild(_span);
      }

      var drawFieldText = function(_flval, _textCont) {
        var _span = document.createElementNS(xmlns, "tspan");
        _span.setAttributeNS(null, "fill", "black");
        _span.setAttributeNS(null, "style", data.font);
        _span.appendChild(document.createTextNode(_flval));
        _textCont.appendChild(_span);
      }

      var dynamicLabel = null;
      var dynamicLabel2 = null;

      var drawDynamicLabelText = function(_flval, _textCont) {
        if (!dynamicLabel) {
          var dynamicLabelSpan = document.createElementNS(xmlns, "tspan");
          dynamicLabelSpan.setAttributeNS(null, "fill", settings.timeBoxFontColor);
          dynamicLabelSpan.setAttributeNS(null, "style", data.font);
          dynamicLabelSpan.appendChild(document.createTextNode(""));
          dynamicLabel = document.createTextNode(_flval);
          dynamicLabelSpan.appendChild(dynamicLabel);
          _textCont.appendChild(dynamicLabelSpan);
        }
        if (_flval) {
          dynamicLabel.nodeValue = _flval;
        }
      }

      var drawDynamicLabelTextTime = function(_flval, _textCont) {
        if (!dynamicLabel2) {
          var dynamicLabelSpan = document.createElementNS(xmlns, "tspan");
          dynamicLabelSpan.setAttributeNS(null, "fill", settings.timeBoxFontColor);
          dynamicLabelSpan.setAttributeNS(null, "style", data.font);
          dynamicLabelSpan.appendChild(document.createTextNode(""));
          dynamicLabel2 = document.createTextNode(_flval);
          dynamicLabelSpan.appendChild(dynamicLabel2);
          _textCont.appendChild(dynamicLabelSpan);
        }
        if (_flval) {
          dynamicLabel2.nodeValue = _flval;
        }
      }

      var drawStatistics = function() {
        var open = getValueLabel2(data.startValue, yAxisArea.scale, data.withCurrency, data.currency.symbol, data.currency.left) + "  ";
        var low = getValueLabel2(data.min, yAxisArea.scale, data.withCurrency, data.currency.symbol, data.currency.left) + "  ";
        var high = getValueLabel2(data.max, yAxisArea.scale, data.withCurrency, data.currency.symbol, data.currency.left) + "  ";
        var close = getValueLabel2(data.endValue, yAxisArea.scale, data.withCurrency, data.currency.symbol, data.currency.left);

        if (settings.chartStatsCallback) {
          settings.chartStatsCallback(open, low, high, close);
        } else {
          var _text = document.createElementNS(xmlns, "text");

          drawFieldLabel("Open: ", _text);
          drawFieldText(open, _text);
          drawFieldLabel(" Low: ", _text);
          drawFieldText(low, _text);
          drawFieldLabel(" High: ", _text);
          drawFieldText(high, _text);
          drawFieldLabel(" Close: ", _text);
          drawFieldText(close, _text);
          //chartTimeZone("", _text);
          _text.setAttributeNS(null, "x", headerArea.x + (plotArea.offset || 0));
          _text.setAttributeNS(null, "y", headerArea.y + headerArea.height - headerArea.margin);
          svgContainer.appendChild(_text);
        }
      }

      var drawTimeZone = function() {
        /*                var _text = document.createElementNS (xmlns, "text");

         drawFieldText("All times in SGT", _text);
         _text.setAttributeNS(null, "x", chartArea.x + xAxisArea.width);
         _text.setAttributeNS(null, "y", xAxisArea.y + 9);
         _text.setAttributeNS(null, "text-anchor", "end");
         svgContainer.appendChild(_text);*/
      }

      var timeLabel = null;
      var _timeLabelBox = null;

      var drawMouseOverTime = function() {

        _timeLabelBox = document.createElementNS(xmlns, "polygon");
        _timeLabelBox.setAttributeNS(null, "points", "");
        _timeLabelBox.setAttributeNS(null, "fill", settings.timeBoxBackgroundColor);
        _timeLabelBox.setAttributeNS(null, "fill-opacity", "1");
        _timeLabelBox.setAttributeNS(null, "stroke", settings.timeBoxBorderColor);
        _timeLabelBox.setAttributeNS(null, "visibility", "hidden");
        svgContainer.appendChild(_timeLabelBox);

        timeLabel = document.createElementNS(xmlns, "text");

        timeLabel.setAttributeNS(null, "text-anchor", "start");
        timeLabel.setAttributeNS(null, "visibility", "hidden");

        svgContainer.appendChild(timeLabel);

      }

      // MARK 
      var timeTest = null;
      var _timeTestBox = null;
      var drawMouseOverTimeTest = function() {

        if (!settings.isRetailDisplay) {
          _timeTestBox = document.createElementNS(xmlns, "polygon");
          _timeTestBox.setAttributeNS(null, "points", "");
          _timeTestBox.setAttributeNS(null, "fill", '#dc8500');
          _timeTestBox.setAttributeNS(null, "fill-opacity", "1");
          _timeTestBox.setAttributeNS(null, "stroke", settings.timeBoxBorderColor);
          _timeTestBox.setAttributeNS(null, "visibility", "hidden");
        } else {
          const x = 0;
          const y = 20;
          const width = 120;
          const height = 40;
          const cornerRadius = 8;

          const defs = document.createElementNS(xmlns, "defs");
          const filter = document.createElementNS(xmlns, "filter");
          filter.setAttribute("id", "rectShadow");
          filter.setAttribute("x", "-10%");
          filter.setAttribute("y", "-10%");
          filter.setAttribute("width", "120%");
          filter.setAttribute("height", "120%");

          const dropShadow = document.createElementNS(xmlns, "feDropShadow");
          dropShadow.setAttribute("dx", "2");
          dropShadow.setAttribute("dy", "2");
          dropShadow.setAttribute("stdDeviation", "3");
          dropShadow.setAttribute("flood-color", "rgba(133,132,132,0.8)");

          filter.appendChild(dropShadow);
          defs.appendChild(filter);
          svgContainer.appendChild(defs);

          _timeTestBox = document.createElementNS(xmlns, "rect");
          _timeTestBox.setAttributeNS(null, "x", x);
          _timeTestBox.setAttributeNS(null, "y", y);
          _timeTestBox.setAttributeNS(null, "width", width);
          _timeTestBox.setAttributeNS(null, "height", height);
          _timeTestBox.setAttributeNS(null, "rx", cornerRadius);
          _timeTestBox.setAttributeNS(null, "ry", cornerRadius);
          _timeTestBox.setAttributeNS(null, "fill", "#dc8500");
          _timeTestBox.setAttributeNS(null, "fill-opacity", "1");
          _timeTestBox.setAttributeNS(null, "stroke", settings.timeBoxBorderColor);
          _timeTestBox.setAttributeNS(null, "visibility", "hidden");
          _timeTestBox.setAttributeNS(null, "filter", "url(#rectShadow)");
        }

        svgContainer.appendChild(_timeTestBox);

        timeTest = document.createElementNS(xmlns, "text");

        timeTest.setAttributeNS(null, "text-anchor", "start");
        timeTest.setAttributeNS(null, "visibility", "hidden");

        svgContainer.appendChild(timeTest);

      }

      var drawDataSeriesArea = function(_index) {
        if (!dataSeries[_index].points) {
          calculatePoints(_index);
        }
        var svg = container.children('svg');
        var defs = svg[0].querySelector("defs");
        if (!defs) {
          defs = document.createElementNS(xmlns, "defs");
          svg[0].appendChild(defs);
        }
        var gradientId = "gradient-fill-" + _index;
        var gradient = document.createElementNS(xmlns, "linearGradient");
        gradient.setAttribute("id", gradientId);
        gradient.setAttribute("x1", "0%");
        gradient.setAttribute("y1", "0%");
        gradient.setAttribute("x2", "0%");
        gradient.setAttribute("y2", "100%");
        var stop1 = document.createElementNS(xmlns, "stop");
        stop1.setAttribute("offset", "0%");
        stop1.setAttribute("stop-color", "#F4DAB2"); // Dark color

        var stop2 = document.createElementNS(xmlns, "stop");
        stop2.setAttribute("offset", "100%");
        stop2.setAttribute("stop-color", "#ffffff"); // Light color

        gradient.appendChild(stop1);
        gradient.appendChild(stop2);
        defs.appendChild(gradient);
        var polygon = document.createElementNS(xmlns, "polygon");
        var pointsStr =
          plotArea.x + "," + (plotArea.y + plotArea.height) + " " +
          dataSeries[_index].points + " " +
          (plotArea.x + plotArea.width) + "," + (plotArea.y + plotArea.height);

        $(polygon).attr({
          "points": pointsStr,
          "fill": "url(#" + gradientId + ")",
          "fill-opacity": "1",
          "stroke": "none"
        });

        svgContainer.appendChild(polygon);
      };

      var drawDataSeriesLine = function(_index) {
        if (!dataSeries[_index].points) {
          calculatePoints(_index);
        }
        var polyline = document.createElementNS(xmlns, "polyline");
        $(polyline).attr({
          "points": dataSeries[_index].points,
          "fill": "none",
          "stroke": (dataSeries[_index].lineColor),
          "stroke-width": (dataSeries[_index].lineWidth),
          "stroke-opacity": "1"
        });
        svgContainer.appendChild(polyline);
      };

      var drawYAxisArea = function(withHorizontalLinesEnds) {
        var currentTick = yAxisArea.maxTickValue;
        var currentTickLabel = null;
        var _text = null;
        var _tick = null;
        var _y = null;
        var _x = yAxisArea.left ? yAxisArea.x : (yAxisArea.x + yAxisArea.tickLength + yAxisArea.tickLabelSpacing);

        yAxisArea.tickPosition.length = 0;

        var _g = document.createElementNS(xmlns, "g");
        _g.setAttributeNS(null, "transform", "translate(0.5,0.5)");

        var _labeledvalue = null;

        while (currentTick >= yAxisArea.minTickValue) {
          var oldTick = currentTick;
          if (_labeledvalue) {
            _labeledvalue = getValueRounded(currentTick, yAxisArea.scale, data.withCurrency, data.currency.symbol, data.currency.left);
          } else {
            yAxisArea.maxTickValue = getValueRounded(currentTick, yAxisArea.scale, data.withCurrency, data.currency.symbol, data.currency.left);
            _labeledvalue = yAxisArea.maxTickValue;
          }

          currentTick = _labeledvalue;

          currentTickLabel = getValueLabel(_labeledvalue, yAxisArea.scale, data.withCurrency, data.currency.symbol, data.currency.left);
          _y = getYCoordinate(currentTick) + yAxisArea.y;

          yAxisArea.tickPosition.push(_y);

          currentTick = currentTick - yAxisArea.majorUnitLabel;
          if (data.numDecimals == 6) {
            currentTick = parseFloat(Math.round(currentTick * 1000000) / 1000000);
          } else if (data.numDecimals == 8) {
            currentTick = parseFloat(Math.round(currentTick * 100000000) / 100000000);
          } else if (data.numDecimals == 7) {
            currentTick = parseFloat(Math.round(currentTick * 10000000) / 10000000);
          } else if (data.numDecimals == 5) {
            currentTick = parseFloat(Math.round(currentTick * 100000) / 100000);
          } else if (data.numDecimals == 4) {
            currentTick = parseFloat(Math.round(currentTick * 10000) / 10000);
          } else if (data.numDecimals == 3) {
            currentTick = parseFloat(Math.round(currentTick * 1000) / 1000);
          } else {
            currentTick = parseFloat(Math.round(currentTick * 100) / 100);
          }

          //dolog('_y:' + _y + ' yAxisArea.y:' + yAxisArea.y);
          if (_y >= yAxisArea.y) {
            //dolog('draw x=' + _x + " y=" + _y + ((settings.fontSize / 2)) + " text=" + currentTickLabel);
            _text = document.createElementNS(xmlns, "text");
            _text.appendChild(document.createTextNode(currentTickLabel));
            _text.setAttributeNS(null, "fill", settings.fontColor);
            _text.setAttributeNS(null, "text-rendering", "optimize-legibility");
            _text.setAttributeNS(null, "style", data.font);
            _text.setAttributeNS(null, "x", _x);
            _text.setAttributeNS(null, "y", _y + (settings.fontSize / 2));
            svgContainer.appendChild(_text);

            if (withHorizontalLinesEnds) {
              _tick = document.createElementNS(xmlns, "line");
              _tick.setAttributeNS(null, "style", "stroke:" + settings.gridColor + ";stroke-width:0.5");
              _tick.setAttributeNS(null, "x1", yAxisArea.x);
              _tick.setAttributeNS(null, "y1", _y);
              _tick.setAttributeNS(null, "x2", (yAxisArea.x + yAxisArea.tickLength) - 5); // MARK: reduce tick length by 5px
              _tick.setAttributeNS(null, "y2", _y);
              _g.appendChild(_tick);
            }
          } else {
            //dolog('NOT draw');
          }

          if (oldTick == currentTick) {
            //doLog('oldTick == currentTick: ' + oldTick + ' == ' + currentTick);
            break;
          }

          //dolog("currentTick:" + currentTick + " minTick:" + yAxisArea.minTickValue + " " + " labeledValue:" + _labeledvalue + " dec:" + yAxisArea.majorUnitLabel);
        }

        if (_labeledvalue != null) {
          //yAxisArea.minTickValue = _labeledvalue;
        }
        yAxisArea.tickRange = yAxisArea.maxTickValue - yAxisArea.minTickValue;

        svgContainer.appendChild(_g);
        //                dolog("max " + yAxisArea.maxTickValue + " min " + yAxisArea.minTickValue + " range " + yAxisArea.tickRange);
      };

      var drawXAxisArea = function(withVerticalLinesEnds, withPlotWidth) {
        var _y = xAxisArea.y + getBoundingBox("1", data.font).height + xAxisArea.tickLength + xAxisArea.tickLabelSpacing;
        var _tickVal = null;
        var _tick = null;
        var _text = null;
        var _x = null;
        var _label = null;
        var _style = null;

        var _g = document.createElementNS(xmlns, "g");
        _g.setAttributeNS(null, "transform", "translate(0.5,0.5)");

        for (var i = 0; i < xAxisArea.tickValues.length; i++) {
          _tickVal = xAxisArea.tickValues[i];
          _x = plotArea.x + _tickVal.x;
          if (_tickVal.label.exact) {
            _label = _tickVal.label.label;
            _style = data.font + "font-weight:bold;";
          } else {
            _label = _tickVal.label.label;
            _style = data.font;
          }

          if (withVerticalLinesEnds) {
            _tick = document.createElementNS(xmlns, "line");
            _tick.setAttributeNS(null, "style", "stroke:" + settings.gridColor + ";stroke-width:1");
            _tick.setAttributeNS(null, "x1", _x);
            _tick.setAttributeNS(null, "y1", xAxisArea.y);
            _tick.setAttributeNS(null, "x2", _x);
            _tick.setAttributeNS(null, "y2", xAxisArea.y + xAxisArea.tickLength);
            _g.appendChild(_tick);
          }

          _text = document.createElementNS(xmlns, "text");
          _text.setAttributeNS(null, "fill", settings.fontColor);
          _text.setAttributeNS(null, "text-rendering", "optimize-legibility");
          _text.setAttributeNS(null, "style", _style);
          var anchor = "middle";
          //console.log('before withPlotWidth');
          if (withPlotWidth) {
            if (_x < xAxisArea.x + 10) {
              //_x = xAxisArea.x + 13;
              _label = '';
            } else if (_x > xAxisArea.x + xAxisArea.width - 10) {
              _label = '';
              //_x = xAxisArea.x + xAxisArea.width - 10;
            }
          } else {
            //console.log('inside _x=' + _x + ' xAxisArea.x=' + xAxisArea.x);
            var tw = getBoundingBox(_label, _style).width;
            if (_x < xAxisArea.x + (tw / 2) + 1) {
              _label = '';
            } else if (_x > xAxisArea.x + xAxisArea.width - ((tw / 2) + 1)) {
              _label = '';
            }
          }
          _text.setAttributeNS(null, "text-anchor", anchor);
          _text.appendChild(document.createTextNode(_label));
          _text.setAttributeNS(null, "x", _x);
          _text.setAttributeNS(null, "y", _y + 7); // MARK: Added 7 to add margin 

          svgContainer.appendChild(_text);
        }

        svgContainer.appendChild(_g);
      };

      var drawGridLines = function(withHorizontalLines, withVerticalLines, withBorder) {
        var _line = null;
        var _x = null;
        var _y = null;
        var _g = document.createElementNS(xmlns, "g");
        _g.setAttributeNS(null, "transform", "translate(0.5,0.5)");

        if (withVerticalLines || !settings.isRetailDisplay) {
          for (var i = 0; i < xAxisArea.tickValues.length; i++) {
            _x = plotArea.x + xAxisArea.tickValues[i].x;

            _line = document.createElementNS(xmlns, "line");
            _line.setAttributeNS(null, "style", "stroke:" + settings.gridColor + ";stroke-width:1;");
            _line.setAttributeNS(null, "x1", _x);
            _line.setAttributeNS(null, "y1", plotArea.y);
            _line.setAttributeNS(null, "x2", _x);
            _line.setAttributeNS(null, "y2", plotArea.y + plotArea.height);
            _g.appendChild(_line);
          }
        }

        if (withHorizontalLines) {
          for (var j = 0; j < yAxisArea.tickPosition.length; j++) {
            _y = yAxisArea.tickPosition[j];

            if (withBorder ? _y > plotArea.y : _y >= plotArea.y) {
              _line = document.createElementNS(xmlns, "line");
              _line.setAttributeNS(null, "style", "stroke:" + settings.gridColor + ";stroke-width:1;");
              _line.setAttributeNS(null, "x1", plotArea.x - settings.gridHorizontalOffset); // MARK: reduce tick length by 3px
              _line.setAttributeNS(null, "y1", _y);
              _line.setAttributeNS(null, "x2", plotArea.x + plotArea.width - settings.gridHorizontalOffset); // MARK: reduce tick length by 3px
              _line.setAttributeNS(null, "y2", _y);

              _g.appendChild(_line);
            }
          }
        }

        svgContainer.appendChild(_g);
      };

      var drawPlotAreaBorder = function() {
        var _g = document.createElementNS(xmlns, "g");
        _g.setAttributeNS(null, "transform", "translate(0.5,0.5)");
        var rect = document.createElementNS(xmlns, "rect");
        rect.setAttributeNS(null, "x", plotArea.x);
        rect.setAttributeNS(null, "y", plotArea.y);
        rect.setAttributeNS(null, "width", plotArea.width);
        rect.setAttributeNS(null, "height", plotArea.height);
        rect.setAttributeNS(null, "style", "fill:none;stroke-width:1;stroke:" + plotArea.borderColor);
        _g.appendChild(rect);
        svgContainer.appendChild(_g);
      };

      var drawNoDataAvail = function() {
        var _text = document.createElementNS(xmlns, "text");
        var msg = "";
        var bmsg = getBoundingBox(msg, data.font);
        _text.appendChild(document.createTextNode(msg));
        _text.setAttributeNS(null, "text-rendering", "optimize-legibility");
        _text.setAttributeNS(null, "fill", settings.fontColor);
        _text.setAttributeNS(null, "style", data.font);
        _text.setAttributeNS(null, "x", (chart.width - bmsg.width) / 2);
        _text.setAttributeNS(null, "y", (chart.height - bmsg.height) / 2);
        svgContainer.appendChild(_text);
      };

      var drawDateCovered = function() {
        var _text = document.createElementNS(xmlns, "text");
        var msg = dateFormat(data.fromDate) + " - " + dateFormat(data.toDate);
        var _msgBox = getBoundingBox(msg);
        _text.appendChild(document.createTextNode(msg));
        _text.setAttributeNS(null, "text-rendering", "optimize-legibility");
        _text.setAttributeNS(null, "fill", settings.fontColor);
        _text.setAttributeNS(null, "style", data.font);
        _text.setAttributeNS(null, "x", plotArea.x + plotArea.width - _msgBox.width);
        _text.setAttributeNS(null, "y", plotArea.y + _msgBox.height);
        svgContainer.appendChild(_text);
      }

      // MARK
      // var drawTimeCovered = function(){
      //     var _text = document.createElementNS (xmlns, "text");
      //     var msg = timeFormat(data.fromDate) + " - " + timeFormat(data.toDate);
      //     var _msgBox = getBoundingBox(msg);
      //     _text.appendChild(document.createTextNode(msg));
      //     _text.setAttributeNS(null, "text-rendering", "optimize-legibility");
      //     _text.setAttributeNS(null, "fill", settings.fontColor);
      //     _text.setAttributeNS(null, "style", data.font);
      //     _text.setAttributeNS(null, "x", plotArea.x + plotArea.width - _msgBox.width);
      //     _text.setAttributeNS(null, "y", plotArea.y + _msgBox.height);
      //     svgContainer.appendChild(_text);
      // }

      var drawLogo = function() {
        var _text = document.createElementNS(xmlns, "text");
        var msg = "BullionStar.com";
        _text.appendChild(document.createTextNode(msg));
        _text.setAttributeNS(null, "text-rendering", "optimize-legibility");
        _text.setAttributeNS(null, "fill", settings.logoColor);
        _text.setAttributeNS(null, "style", data.font);
        _text.setAttributeNS(null, "x", plotArea.x + 5);
        _text.setAttributeNS(null, "y", plotArea.y + plotArea.height - 5);
        svgContainer.appendChild(_text);
      }

      function drawVerticalPointDataLineForRetail(_pointData, line1X, line2X) {
        var existingLine = svgContainer.querySelector('.vertical-point-data-line');
        if (existingLine) {
          svgContainer.removeChild(existingLine);
        }
        var _line = null;
        var _x = _pointData.x;
        var _y = _pointData.y;
        var _g = document.createElementNS(xmlns, "g");
        _g.setAttributeNS(null, "class", "vertical-point-data-line");
        _line1 = document.createElementNS(xmlns, "line");
        _line1.setAttributeNS(null, "style", "stroke: " + settings.labelLineColor + ";stroke-width:1;stroke-dasharray:2.5,1,2.5,5; stock-opacity:0.4");
        _line1.setAttributeNS(null, "x1", plotArea.x - settings.gridHorizontalOffset);
        _line1.setAttributeNS(null, "y1", _y);
        _line1.setAttributeNS(null, "x2", line1X);
        _line1.setAttributeNS(null, "y2", _y);
        _g.appendChild(_line1);
        _line2 = document.createElementNS(xmlns, "line");
        _line2.setAttributeNS(null, "style", "stroke: " + settings.labelLineColor + ";stroke-width:1;stroke-dasharray:2.5,1,2.5,5; stock-opacity:0.4");
        _line2.setAttributeNS(null, "x1", line2X);
        _line2.setAttributeNS(null, "y1", _y);
        _line2.setAttributeNS(null, "x2", _x);
        _line2.setAttributeNS(null, "y2", _y);
        _g.appendChild(_line2);
        svgContainer.appendChild(_g);
      }

      var drawLineCursor = function() {
        // Create an SVGPoint for future math
        var pt = svgContainer.createSVGPoint();

        var _lineCursorG = document.createElementNS(xmlns, "g");
        var _lineCursor = document.createElementNS(xmlns, "path");
        _lineCursor.setAttributeNS(null, "stroke", settings.lineCursorColor);
        _lineCursor.setAttributeNS(null, "stroke-width", settings.lineCursorWeight);
        if (settings.lineCursorDashArray) _lineCursor.setAttributeNS(null, "stroke-dasharray", settings.lineCursorDashArray);

        _lineCursorG.appendChild(_lineCursor);
        svgContainer.appendChild(_lineCursorG);

        var _lineCursorVG = document.createElementNS(xmlns, "g");
        var _lineCursorV = document.createElementNS(xmlns, "path");
        _lineCursorV.setAttributeNS(null, "stroke", settings.lineCursorColor);
        _lineCursorV.setAttributeNS(null, "stroke-width", settings.lineCursorWeight);
        if (settings.lineCursorDashArray) _lineCursorV.setAttributeNS(null, "stroke-dasharray", settings.lineCursorDashArray);

        _lineCursorVG.appendChild(_lineCursorV);
        svgContainer.appendChild(_lineCursorVG);

        // var _g = document.createElementNS (xmlns, "g");
        // _g.setAttributeNS(null, "transform", "translate(0.5,0.5)");
        // var _rect = document.createElementNS(xmlns, "rect");
        // _rect.setAttributeNS(null, "x", plotArea.x + plotArea.width);
        // _rect.setAttributeNS(null, "width", chart.width - plotArea.x - plotArea.width);
        // _rect.setAttributeNS(null, "height", settings.lineCursorBoxHeight);
        // _rect.setAttributeNS(null, "style", "fill:" + (settings.lineCursorTextBGColor ? settings.lineCursorTextBGColor : "#ba741e")  + ";stroke-width:1;");
        // _g.appendChild(_rect);
        // svgContainer.appendChild(_g);

        var _lineCursorText = document.createElementNS(xmlns, "text");
        var _lineCursorValue = document.createTextNode("");
        _lineCursorText.appendChild(_lineCursorValue);
        _lineCursorText.setAttributeNS(null, "fill", (settings.lineCursorTextColor ? settings.lineCursorTextColor : "#ffffff"));
        _lineCursorText.setAttributeNS(null, "text-rendering", "optimize-legibility");
        _lineCursorText.setAttributeNS(null, "style", data.font);
        _lineCursorText.setAttributeNS(null, "x", plotArea.x + plotArea.width + 5); // MARK To be continue

        svgContainer.appendChild(_lineCursorText);

        var _cursorIndicator = document.createElementNS(xmlns, "circle");
        _cursorIndicator.setAttributeNS(null, "cx", 0);
        _cursorIndicator.setAttributeNS(null, "cy", 0);
        _cursorIndicator.setAttributeNS(null, "r", settings.cursorPointSize);
        _cursorIndicator.setAttributeNS(null, "stroke", settings.cursorPointStrokeColor);
        _cursorIndicator.setAttributeNS(null, "stroke-width", "1");
        _cursorIndicator.setAttributeNS(null, "fill", settings.cursorPointColor);

        svgContainer.appendChild(_cursorIndicator);

        // Get point in global SVG space
        function cursorPoint(evt) {
          pt.x = evt.clientX;
          pt.y = evt.clientY;
          return pt.matrixTransform(svgContainer.getScreenCTM().inverse());
        }

        function createCursorCoord(_lineCursorY) {
          return "M" + (plotArea.x + 1) + " " + _lineCursorY + " L" + (plotArea.x + plotArea.width) + " " + _lineCursorY;
        }

        function createCursorCoordV(_lineCursorX) {
          return "M" + _lineCursorX + " " + (plotArea.y) + " L" + _lineCursorX + " " + (plotArea.y + plotArea.height);
        }

        function createTimeBox(x, width, y) {
          var boxHeight = settings.timeBoxHeight;
          var yAxis = y - 14;

          var right = x + width;

          return "" + right + "," + (yAxis) +
            " " + x + "," + (yAxis) +
            " " + x + "," + (yAxis - boxHeight) +
            " " + right + "," + (yAxis - boxHeight);
        }

        // MARK
        function createValueBox(x, width, y) {
          var boxHeight = settings.timeBoxHeight;
          // Set Y Position of the Value Time Box
          var yAxis = y - 14; // plotAray.y
          var right = x + width;

          return "" + right + "," + (yAxis) +
            " " + x + "," + (yAxis) +
            " " + x + "," + (yAxis - boxHeight) +
            " " + right + "," + (yAxis - boxHeight);
        }

        function updatePointDataCursor(_pointData) {
          if (_pointData) {
            var timeText = dateFormat(_pointData.date, settings.timeZone);
            var timeTextWidth = getBoundingBox(timeText, data.font).width;
            var valueText = getValueLabel2(_pointData.value, yAxisArea.scale, data.withCurrency, data.currency.symbol, data.currency.left, settings.showWeightSymbol, settings.weightSymbol);
            var valueTextWidth = getBoundingBox(valueText, data.font).width;
            //console.log('timeText: ' + timeText + ' width: ' + timeTextWidth);
            //console.log('valueText: ' + valueText + ' width: ' + valueTextWidth);
            var valueBoxWidth = valueTextWidth + 15;
            var timeBoxWidth = timeTextWidth + 15;
            var totalWidth = valueBoxWidth + timeBoxWidth;
            var startX = _pointData.x - timeBoxWidth;

            if (startX < 0) {
              startX = 0;
            }

            if (startX + totalWidth > plotArea.width) {
              startX = plotArea.width - totalWidth;
            }

            var valueBoxX = startX + timeBoxWidth;

            _lineCursorG.setAttributeNS(null, "visibility", "visible");
            _lineCursorVG.setAttributeNS(null, "visibility", "visible");
            _lineCursorText.setAttributeNS(null, "visibility", "visible");
            _cursorIndicator.setAttributeNS(null, "visibility", "visible");
            if (settings.isRetailDisplay) {
              _timeLabelBox.setAttributeNS(null, "visibility", "hidden");
              timeLabel.setAttributeNS(null, "visibility", "hidden");
            } else {
              _timeLabelBox.setAttributeNS(null, "visibility", "visible");
              timeLabel.setAttributeNS(null, "visibility", "visible");
            }
            var _lineCursorX = _pointData.x - 30; // - 30 to move it 30px left of the X axis
            var _lineCursorY = _pointData.y;

            var _lineCursorCoord = createCursorCoord(_lineCursorY);
            var _lineCursorCoordV = createCursorCoordV(_lineCursorX);
            _lineCursor.setAttributeNS(null, "d", _lineCursorCoord);
            _lineCursorV.setAttributeNS(null, "d", _lineCursorCoordV);
            //_lineCursorText.setAttributeNS(null, "y", _lineCursorY + settings.lineCursorTextYOffset);
            //_rect.setAttributeNS(null, "y", (_lineCursorY - (settings.lineCursorBoxHeight/2) - settings.valueBoxYOffset));
            //_lineCursorValue.nodeValue = getValueLabel2(_pointData.value, yAxisArea.scale, data.withCurrency, data.currency.symbol, data.currency.left);
            _cursorIndicator.setAttributeNS(null, "cx", _pointData.x);
            _cursorIndicator.setAttributeNS(null, "cy", _pointData.y);

            _timeLabelBox.setAttributeNS(null, "points", createTimeBox(startX, timeBoxWidth, _pointData.y));


            timeLabel.setAttributeNS(null, "x", startX + 5);
            // Set Y Position of the Date Text inside Time Box 
            timeLabel.setAttributeNS(null, "y", _pointData.y - (settings.timeBoxMarginTop + 20));

            drawDynamicLabelText(timeText, timeLabel);

            // MARK
            _timeTestBox.setAttributeNS(null, "visibility", "visible");
            timeTest.setAttributeNS(null, "visibility", "visible");

            _timeTestBox.setAttributeNS(null, "points", createValueBox(valueBoxX, valueBoxWidth, _pointData.y));

            if (settings.isRetailDisplay) {
              _timeTestBox.setAttributeNS(null, "x", _pointData.x - 150);
              _timeTestBox.setAttributeNS(null, "y", _pointData.y - (settings.timeBoxMarginTop + 20));
              _timeTestBox.setAttributeNS(null, "fill", settings.timeBoxBackgroundColor);
              timeTest.setAttributeNS(null, "x", _pointData.x + 10 - 150);
              timeTest.setAttributeNS(null, "y", _pointData.y - ((settings.timeBoxMarginTop) - 6));
              timeTest.setAttributeNS(null, "style", "font-size: 20px; font-weight: bold; fill: " + settings.timeBoxTextColor + ";");
            } else {
              timeTest.setAttributeNS(null, "x", valueBoxX + 5);
              // Set Y Position of the Value Text inside Time Box
              timeTest.setAttributeNS(null, "y", _pointData.y - (settings.timeBoxMarginTop + 20));

            }
            drawDynamicLabelTextTime(valueText, timeTest);

            if (settings.updateCursor) {
              settings.updateCursor(_pointData);
            }
          } else {
            _lineCursorG.setAttributeNS(null, "visibility", "hidden");
            _lineCursorVG.setAttributeNS(null, "visibility", "hidden");
            _g.setAttributeNS(null, "visibility", "hidden");
            _lineCursorText.setAttributeNS(null, "visibility", "hidden");
            _cursorIndicator.setAttributeNS(null, "visibility", "hidden");
            _timeLabelBox.setAttributeNS(null, "visibility", "hidden");
            timeLabel.setAttributeNS(null, "visibility", "hidden");
          }
          if (settings.isRetailDisplay) {
            drawVerticalPointDataLineForRetail(_pointData, _pointData.x - 150, _pointData.x - 30);
          }
        }

        if (settings.withLineCursorMouseMove) {
          svgContainer.addEventListener('mousemove', function(evt) {
            var _loc = cursorPoint(evt);
            var _pointData = null;

            var x = Math.round(_loc.x);
            if ((x < plotArea.x) || (x > (plotArea.x + plotArea.width))) {
              _pointData = dataSeries[0].pointsmap[dataSeries[0].pointsmaplastkey];
            } else {
              _pointData = dataSeries[0].pointsmap[x];
              if (!_pointData) {
                while (x-- > 0 && !_pointData) {
                  _pointData = dataSeries[0].pointsmap[x];
                }
              }
            }

            updatePointDataCursor(_pointData);
          }, false);

          // add event listener for losing focus of div with id = main-chart
          $('#main-chart').on('mouseleave', function() {
            updatePointDataCursor(dataSeries[0].pointsmap[dataSeries[0].pointsmaplastkey]);
          });

        }

        if (settings.enableDrag) {
          svgContainer.addEventListener('touchmove', function(evt) {
            var _loc = cursorPoint(evt.changedTouches[0]);
            var _pointData = null;

            var x = Math.round(_loc.x);
            if ((x < plotArea.x) || (x > (plotArea.x + plotArea.width))) {
              _pointData = dataSeries[0].pointsmap[dataSeries[0].pointsmaplastkey];
            } else {
              _pointData = dataSeries[0].pointsmap[x];
              if (!_pointData) {
                while (x-- > 0 && !_pointData) {
                  _pointData = dataSeries[0].pointsmap[x];
                }
              }
            }

            updatePointDataCursor(_pointData);
          }, false);
        }

        updatePointDataCursor(dataSeries[0].pointsmap[dataSeries[0].pointsmaplastkey]);
      }

      // *************************
      //    Start drawing graph
      // *************************
      drawContainer();

      if (successSetup) {

        if (settings.chartTitle) {
          drawTitle();
        }

        if (settings.withStatistics) {
          drawStatistics();
        }

        if (settings.withTimeZone) {
          drawTimeZone();
        }

        drawYAxisArea(settings.withHorizontalLinesEnds);
        drawXAxisArea(settings.withVerticalLinesEnds, settings.plotWidth ? true : false);
        drawGridLines(settings.withHorizontalLines, settings.withVerticalLines, settings.withBorder);

        $.each(dataSeries, function(_index, seriesData) {
          if (seriesData.area) {
            drawDataSeriesArea(_index);
          }
          drawDataSeriesLine(_index);
        });

        if (settings.withBorder) {
          drawPlotAreaBorder();
        }

        if (settings.withDateCovered) {
          drawDateCovered();
        }

        if (settings.withLogo) {
          drawLogo();
        }

        if (settings.withLineCursor) {
          //dolog('before drawLineCursor');
          drawMouseOverTime();
          drawMouseOverTimeTest();
          drawLineCursor();
        }


      } else {
        drawNoDataAvail();
      }

      return true;
    }
  };

  $.fn.bstarchart = function(options) {
    if (options && options.type) {
      if (types[options.type]) {
        if (!_tempDiv) {
          _tempDiv = document.createElement("div");
          _tempDiv.setAttribute("style", "position:absolute;top:-1000px;");
          document.body.appendChild(_tempDiv);
        }
        return types[options.type].apply(this, Array.prototype.slice.call(arguments, 0));
      } else {
        $.error('Chart type ' + options.type + ' does not exist on jQuery.bsstarchart');
      }
    } else {
      $.error('Parameter options and options.type are required.');
    }

  };
})(jQuery);